var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-scroll-view", { staticClass: "order-preview-content" }, [
    _c(
      "div",
      { staticClass: "order-preview-inner" },
      [
        _c("w-info", {
          staticClass: "mb no-print",
          attrs: {
            text: _vm.$ct("no-pdf-info"),
            "ico-lib": "fas",
            ico: "info-circle",
          },
        }),
        _c(
          "w-row",
          { staticClass: "parties" },
          [
            _c(
              "w-col",
              { attrs: { xs: "12", md: "6" } },
              [
                _c("div", { staticClass: "party-label" }, [
                  _vm._v(_vm._s(_vm.$ct("customer"))),
                ]),
                _c("app-party", { attrs: { party: _vm.order.Customer } }),
              ],
              1
            ),
            _c(
              "w-col",
              { attrs: { xs: "12", md: "6" } },
              [
                _c("div", { staticClass: "party-label" }, [
                  _vm._v(_vm._s(_vm.$ct("supplier"))),
                ]),
                _c("app-party", { attrs: { party: _vm.order.Supplier } }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "w-row",
          { staticClass: "dates-row" },
          [
            _c("w-col", { attrs: { xs: "12", md: "4" } }, [
              _c("div", { staticClass: "date-item" }, [
                _c("span", { staticClass: "date-label" }, [
                  _vm._v(_vm._s(_vm.$ct("invoice-date"))),
                ]),
                _c("span", { staticClass: "date-value" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.order.OrderDate))),
                ]),
              ]),
            ]),
            _c("w-col", { attrs: { xs: "12", md: "4" } }, [
              _c("div", { staticClass: "date-item" }, [
                _c("span", { staticClass: "date-label" }, [
                  _vm._v(_vm._s(_vm.$ct("due-date"))),
                ]),
                _c("span", { staticClass: "date-value" }, [
                  _vm._v(_vm._s(_vm.formatDate(_vm.order.ExpiryDate))),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _c("div", { staticClass: "section-title" }, [
          _vm._v(
            _vm._s(_vm.$ct("order-lines")) + " " + _vm._s(_vm.order.OrderNumber)
          ),
        ]),
        _c("table", { staticClass: "order-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "text-left col-qty" }, [
                _vm._v(_vm._s(_vm.$ct("qty"))),
              ]),
              _c("th", { staticClass: "text-left col-desc" }, [
                _vm._v(_vm._s(_vm.$ct("description"))),
              ]),
              _c("th", { staticClass: "text-right col-price" }, [
                _vm._v(_vm._s(_vm.$ct("unit-price"))),
              ]),
              _c("th", { staticClass: "text-right col-amount" }, [
                _vm._v(_vm._s(_vm.$ct("netto"))),
              ]),
              _c("th", { staticClass: "text-right col-vat" }, [
                _vm._v(_vm._s(_vm.$ct("vat"))),
              ]),
              _c("th", { staticClass: "text-right col-amount" }, [
                _vm._v(_vm._s(_vm.$ct("bruto"))),
              ]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.order.OrderLines, function (line, i) {
              return _c("app-line", { key: i, attrs: { line: line } })
            }),
            1
          ),
        ]),
        _c("div", { staticClass: "section-title" }, [
          _vm._v(_vm._s(_vm.$ct("vat-summary"))),
        ]),
        _c("table", { staticClass: "totals-table" }, [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$ct("total-excl"))),
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$ct("vat-percentage"))),
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$ct("total-vat"))),
              ]),
              _c("th", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.$ct("total-incl"))),
              ]),
            ]),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.order.VatGroups, function (group, i) {
              return _c("app-vat-group", {
                key: i,
                attrs: { "vat-group": group },
              })
            }),
            1
          ),
          _c("tfoot", [
            _c("tr", { staticClass: "grand-total" }, [
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatNumber(_vm.order.TotalExcl))),
              ]),
              _c("td"),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatNumber(_vm.order.TotalVAT))),
              ]),
              _c("td", { staticClass: "text-right" }, [
                _vm._v(_vm._s(_vm.formatNumber(_vm.order.TotalIncl))),
              ]),
            ]),
          ]),
        ]),
        _vm.hasPaymentInfo
          ? _c("div", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$ct("payment-info"))),
            ])
          : _vm._e(),
        _vm.hasPaymentInfo
          ? _c("div", { staticClass: "payment-info" }, [
              _vm.order.PaymentReference
                ? _c("div", { staticClass: "payment-row" }, [
                    _c("span", { staticClass: "payment-label" }, [
                      _vm._v(_vm._s(_vm.$ct("payment-reference"))),
                    ]),
                    _c("span", { staticClass: "payment-value" }, [
                      _vm._v(_vm._s(_vm.order.PaymentReference)),
                    ]),
                  ])
                : _vm._e(),
              _vm.bankAccountIban
                ? _c("div", { staticClass: "payment-row" }, [
                    _c("span", { staticClass: "payment-label" }, [
                      _vm._v(_vm._s(_vm.$ct("iban"))),
                    ]),
                    _c("span", { staticClass: "payment-value" }, [
                      _vm._v(_vm._s(_vm.bankAccountIban)),
                    ]),
                  ])
                : _vm._e(),
              _vm.bankAccountBic
                ? _c("div", { staticClass: "payment-row" }, [
                    _c("span", { staticClass: "payment-label" }, [
                      _vm._v(_vm._s(_vm.$ct("bic"))),
                    ]),
                    _c("span", { staticClass: "payment-value" }, [
                      _vm._v(_vm._s(_vm.bankAccountBic)),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }